import { DatePipe } from '@angular/common';
import {
    Inject,
    Injectable,
    LOCALE_ID,
    Pipe,
    PipeTransform,
} from '@angular/core';

@Pipe({
    name: 'dateTime',
    standalone: true,
})
@Injectable({ providedIn: 'root' })
export class DateTimePipe implements PipeTransform {
    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private datePipe: DatePipe
    ) {}

    transform(date: string): string {
        const _MS_PER_DAY = 86400000;
        const dateTime = new Date(date);
        const dateToday = new Date();
        const dateTimeUTC = Date.UTC(
            dateTime.getFullYear(),
            dateTime.getMonth(),
            dateTime.getDate(),
            dateTime.getHours(),
            dateTime.getMinutes(),
            dateTime.getSeconds()
        );
        const dateTodayUTC = Date.UTC(
            dateToday.getFullYear(),
            dateToday.getMonth(),
            dateToday.getDate(),
            dateToday.getHours(),
            dateToday.getMinutes(),
            dateToday.getSeconds()
        );
        const dateMidnightUTC = Date.UTC(
            dateToday.getFullYear(),
            dateToday.getMonth(),
            dateToday.getDate(),
            0,
            0,
            0
        );

        const diffSecs = Math.floor((dateTodayUTC - dateTimeUTC) / 1000);
        const isToday = dateTimeUTC >= dateMidnightUTC;
        const isYesterday =
            dateTimeUTC >= dateMidnightUTC - _MS_PER_DAY &&
            dateTimeUTC < dateMidnightUTC;

        let updatedTime: string;

        if (diffSecs < 60) {
            updatedTime = $localize`Just now`;
        } else if (diffSecs >= 60 && isToday) {
            updatedTime = $localize`Today, ${this.datePipe.transform(
                dateTime,
                'shortTime'
            )}`;
        } else if (isYesterday) {
            updatedTime = $localize`Yesterday, ${this.datePipe.transform(
                dateTime,
                'shortTime'
            )}`;
        } else {
            updatedTime = $localize`${this.datePipe.transform(
                dateTime,
                'short',
                this.locale
            )}`;
        }

        return updatedTime;
    }
}
